// extracted by mini-css-extract-plugin
module.exports = {"pcItem":"pcItem___Xsma_","title":"title___2iUHn","img":"img___m01sm","mobileItem":"mobileItem___13HII"};